module.exports = __webpack_public_path__ + "public/images/video-games.8bcd5b2c2ec6d9094ba4cc55c5ab15ba.jpg";